interface ProgressBarProps {
  progress: number; // 0–100
}

export default function ProgressBar({ progress }: ProgressBarProps) {
  return (
    <div className="h-1 w-full bg-gray-100">
      <div
        className="h-full bg-brand-500 transition-all duration-500 ease-out"
        style={{ width: `${Math.min(100, Math.max(0, progress))}%` }}
      />
    </div>
  );
}
